import type { Xinglet } from '@xing-com/crate-xinglet';

import type { ContainerProps } from './container';
import { Container } from './container';

export default class JobDetailsPushNotification implements Xinglet {
  public getComponent() {
    return ({ jobId }: ContainerProps): JSX.Element => (
      <Container jobId={jobId} />
    );
  }
}
